<script>
    import Messages from "./helpers/messages/Messages";
    import Auth from "./helpers/Auth";

    export let language = 'en-US';
    export let auth_endpoint = '/auth/';

    export let csrfKey = '_csrf';
    export let csrfValue = null;

    Messages.registerLanguageVersion(language);

    let email = '';
    let password = '';

    let mainError = null;
    let emailError = null;
    let passwordError = null;

    let loading = false;

    const auth = new Auth({
        auth_endpoint
    });

    const signUp = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        emailError = null;
        passwordError = null;

        try {
            const response = await auth.signup(email, password, csrfKey, csrfValue);
            console.log(response);
            if (response.status === 'ok') {
                window.location.href = `/`;
            }
        } catch (error) {
            console.error(error);
            if (error.response.data.errors) {
                if (error.response.data.errors.password) {
                    passwordError = error.response.data.errors.password;
                }

                if (error.response.data.errors.mail) {
                    emailError = error.response.data.errors.mail;
                }
            }
        }
    }
</script>

<header>
    <a href="/" class="logo {language}"></a>
</header>

<div class="clean-signup-form">
    <form class="auth-form" on:submit = {signUp}>
        {#if mainError}
            <div class="error">{mainError}</div>
        {/if}

        <h1 class="text-center">
            {Messages.t('signup_form', 'TITLE')}
        </h1>

        {#if language === 'ru-RU'}
            <p class="text-center">{Messages.t('signup_form', 'MESSAGE')}</p>
        {:else}
            <div class="button-google" role="button" title="Google" on:click={ () => {window.location.href = 'https://accounts.google.com/o/oauth2/v2/auth?response_type=code&access_type=online&client_id=161432133356-03569850460t9lbuemr6airq34vetv27.apps.googleusercontent.com&redirect_uri=https%3A%2F%2Fdatajam.pro%2Finstashpion%2Fgoogle-auth&state&scope=email&approval_prompt=auto'; }}>

                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 10px;">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M34.8345 18.1767C34.8345 16.9164 34.7214 15.7047 34.5114 14.5414H17.7727V21.4162H27.3377C26.9257 23.6378 25.6735 25.5201 23.7912 26.7803V31.2396H29.535C32.8957 28.1456 34.8345 23.5893 34.8345 18.1767Z" fill="#4285F4"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7727 35.5455C22.5714 35.5455 26.5945 33.954 29.5351 31.2397L23.7912 26.7803C22.1998 27.8467 20.164 28.4768 17.7727 28.4768C13.1438 28.4768 9.22567 25.3504 7.82809 21.1496H1.89038V25.7544C4.8148 31.5628 10.8252 35.5455 17.7727 35.5455Z" fill="#34A853"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.82808 21.1496C7.47263 20.0832 7.27066 18.9441 7.27066 17.7727C7.27066 16.6014 7.47263 15.4623 7.82808 14.3959V9.79118H1.89037C0.686674 12.1905 0 14.9049 0 17.7727C0 20.6406 0.686674 23.355 1.89037 25.7543L7.82808 21.1496Z" fill="#FBBC05"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7727 7.0687C20.3821 7.0687 22.7249 7.96542 24.5668 9.72653L29.6643 4.62899C26.5864 1.76112 22.5633 0 17.7727 0C10.8252 0 4.8148 3.98271 1.89038 9.79116L7.82809 14.3959C9.22567 10.1951 13.1438 7.0687 17.7727 7.0687Z" fill="#EA4335"/>
                </svg>

                <span>Sign up with Google</span>
            </div>
            <p class="text-center">or</p>
        {/if}

        <div class="field-node" class:error = {emailError}>
            <input placeholder={Messages.t('form', 'PLACEHOLDER_EMAIL')} type="text" name="email" id="email" autocomplete="off" bind:value={email} />
            {#if emailError}
                <div class="error">{emailError}</div>
            {/if}
        </div>

        <div class="field-node" class:error = {passwordError}>
            <input placeholder={Messages.t('form', 'PLACEHOLDER_PASSWORD')} type="password" name="password" id="password" autocomplete="off" bind:value={password} />
            {#if passwordError}
                <div class="error">{passwordError}</div>
            {/if}
        </div>
        <div class="field-node">
            <button class:loading = {loading}>{Messages.t('signup_form', 'BUTTON')}</button>
        </div>
        {#if language === 'ru-RU'}
            <div>
                <div class="field-node text-center">{Messages.t('form', 'SOCIAL_MESSAGE')}</div>
                <div class="field-node text-center socials">
                    <div class="ulogin-panel">
                        <div class="ulogin-buttons-container">
                                <div on:click = {(e) => {window.location.href = e.target.getAttribute('data-href')}} data-href = "https://oauth.vk.com/authorize?client_id=7281535&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dvkontakte%26redirectUrl%3Dhttps%253A%252F%252Finstashpion.ru%252Fauth%252Flogin&response_type=code&scope=email" class="ulogin-button-vkontakte " role="button" title="VK"></div>
                                <div on:click = {(e) => {window.location.href = e.target.getAttribute('data-href')}} data-href = "https://accounts.google.com/o/oauth2/v2/auth?response_type=code&access_type=online&client_id=239064102104-clanfu6udga8akf3dga8e6v0fu3ed144.apps.googleusercontent.com&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dgoogle%26redirectUrl%3Dhttps%3A%2F%2Finstashpion.ru%2Fauth%2Flogin&state&scope=email&approval_prompt=auto" class="ulogin-button-google" role="button" title="Google"></div>
                                <div on:click = {(e) => {window.location.href = e.target.getAttribute('data-href')}} data-href = "https://connect.mail.ru/oauth/authorize?client_id=768740&response_type=code&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dmailru%26redirectUrl%3Dhttps%253A%252F%252Finstashpion.ru%252Fauth%252Flogin" class="ulogin-button-mailru" role="button" title="Mail.ru"></div>
                                <div on:click = {(e) => {window.location.href = e.target.getAttribute('data-href')}} data-href = "https://connect.ok.ru/oauth/authorize?client_id=512000333191&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dodnoklassniki%26redirectUrl%3Dhttps%3A%2F%2Finstashpion.ru%2Fauth%2Flogin&response_type=code&scope=GET_EMAIL" class="ulogin-button-odnoklassniki" role="button" title="Odnoklassniki"></div>

                        </div>
                    </div>
                </div>
            </div>
        {/if}
        <div class="field-node text-center">
            {Messages.t('signup_form', 'LOGIN_PHRASE')} <a href="/auth/instashpion-login">{Messages.t('signup_form', 'LOGIN_LINK')}</a>
        </div>
    </form>
</div>
{#if false && language === 'ru-RU'}
    <p class="text-center privacy-text">
        Совершая регистрацию Вы даете согласие на обработку персональной <br>
        информации на условиях, определенных <a href="/privacy.pdf">Политикой конфиденциальности</a>.
    </p>
{/if}

<style lang="scss">
  @import "style";

  .logo {
    &.ru-RU {
      background: url(https://auth.zengram.ru/themes/spy/logo.png) no-repeat center;
      width: 260px;
    }

    &.en-US {
      background: url(https://auth.datajam.pro/themes/spy/datajam-black-logo.png) no-repeat center;
      background-size: 100%;
      width: 170px;
    }
  }
</style>